// extracted by mini-css-extract-plugin
module.exports = {"list":"list_vkG","left-col":"left-col_B_X","right-col":"right-col_70x","header":"header_3Xd","main":"main_1_e"};